import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact">
      <h1 className="contact-title">Get in Touch</h1>
      <p className="contact-subtitle">
        For custom orders, wholesale inquiries, or just to say hello
      </p>

      <div className="contact-content">
        <div className="contact-info">
          <div className="contact-item">
            <h3>Email</h3>
            <a href="mailto:hello@jays-clays.com">hello@jays-clays.com</a>
          </div>
          <div className="contact-item">
            <h3>Instagram</h3>
            <a href="https://instagram.com/jays.clays" target="_blank" rel="noopener noreferrer">
              @jays.clays
            </a>
          </div>
          <div className="contact-item">
            <h3>Location</h3>
            <p>Brooklyn, NY</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
